import React, { useState, useEffect } from 'react';
import { authorizationApi } from '../../../services/authorizationApiService';
import PolicyDetailsModal from './components/PolicyDetailsModal';
import Button from '../../common/Button/Button';
import SearchBar from '../../common/SearchBar/SearchBar';
import Table from '../../common/Table/Table';

export default function PoliciesTab() {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  useEffect(() => {
    loadPolicies();
  }, []);

  const loadPolicies = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await authorizationApi.getPolicies();
      // Extract policies array from response object
      setPolicies(data?.policies || []);
    } catch (err) {
      console.error('Error loading policies:', err);
      setError(err.message || 'Failed to load policies');
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (policy) => {
    setSelectedPolicy(policy);
    setShowDetailsModal(true);
  };

  const filteredPolicies = policies.filter(policy =>
    policy.policy_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    policy.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    policy.policy_id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    {
      header: 'Policy Name',
      accessor: 'policy_name',
      width: '200px',
      render: (policy) => <span className="name-col">{policy.policy_name}</span>
    },
    {
      header: 'Description',
      accessor: 'description',
      render: (policy) => <span className="description-col">{policy.description}</span>
    },
    {
      header: 'Permissions',
      width: '130px',
      render: (policy) => (
        <span className="count-text">
          {policy.permissions?.length || 0} {policy.permissions?.length === 1 ? 'permission' : 'permissions'}
        </span>
      )
    },
    {
      header: 'Actions',
      width: '170px',
      render: (policy) => (
        <Button
          variant="secondary"
          size="sm"
          icon="fas fa-eye"
          onClick={() => handleViewDetails(policy)}
        >
          View Details
        </Button>
      )
    }
  ];

  if (error) {
    return (
      <div className="error-state">
        <i className="fas fa-exclamation-circle"></i>
        <h4>Error Loading Policies</h4>
        <p>{error}</p>
          <Button variant="primary" icon="fas fa-redo" onClick={loadPolicies}>
            Retry
          </Button>
      </div>
    );
  }

  return (
    <div className="policies-tab">
      <div className="policies-actions">
        <div className="search-wrapper">
          <SearchBar
            placeholder="Search policies..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <Button variant="secondary" icon="fas fa-redo" onClick={loadPolicies} />
      </div>

      <Table
        columns={columns}
        data={filteredPolicies}
        isLoading={loading}
        emptyMessage={searchTerm ? 'No policies match your search criteria.' : 'No policies have been configured yet.'}
        emptyIcon="fas fa-shield-alt"
      />

      {showDetailsModal && selectedPolicy && (
        <PolicyDetailsModal
          policy={selectedPolicy}
          onClose={() => {
            setShowDetailsModal(false);
            setSelectedPolicy(null);
          }}
        />
      )}
    </div>
  );
}
